/** Master Spec §30. Keep in sync with database/schema/users.ts role enum. */
export const USER_ROLES = ["student", "teacher", "admin"] as const;
export type UserRole = (typeof USER_ROLES)[number];
